import React from 'react';
import { Badge } from '../ui/badge';
import { HsmContactSortKey } from '../../types';
import { getSortIcon as _getSortIcon } from '../../utils/sort-icon';

/**
 * Returns the appropriate sort icon based on whether the column is active and the sort direction.
 * Delegates to the shared getSortIcon utility in src/utils/sort-icon.tsx.
 */
export function getSortIcon(isActive: boolean, direction: 'asc' | 'desc'): React.ReactElement {
  return _getSortIcon(isActive, direction) as React.ReactElement;
}

/**
 * Returns the ARIA sort attribute value for accessibility.
 */
export function getAriaSort(
  column: HsmContactSortKey,
  currentColumn: HsmContactSortKey,
  direction: 'asc' | 'desc'
): 'ascending' | 'descending' | 'none' {
  return currentColumn === column
    ? direction === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';
}

/**
 * Contact status configuration map for badge rendering.
 */
export const contactStatusMap: Record<
  string,
  { variant: 'pending' | 'active' | 'paused' | 'completed' | 'optedOut'; label: string }
> = {
  PENDING: { variant: 'pending', label: 'Pendente' },
  ACTIVE: { variant: 'active', label: 'Ativo' },
  INACTIVE: { variant: 'paused', label: 'Inativo' },
  PAUSED: { variant: 'paused', label: 'Pausado' },
  COMPLETED: { variant: 'completed', label: 'Concluido' },
  OPTED_OUT: { variant: 'optedOut', label: 'Opt-out' },
};

/**
 * Returns a Badge component for the given contact status.
 */
export function getContactStatusBadge(status: string): React.ReactElement {
  const config = contactStatusMap[status] || {
    variant: 'pending' as const,
    label: status || 'Desconhecido',
  };
  return React.createElement(Badge, { variant: config.variant }, config.label);
}
